export enum DEVICE_ENUM {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
    TABLET = 'tablet',
}

export const PREVIEW_SIZE_MAP = {
    [DEVICE_ENUM.DESKTOP]: '100%',
    [DEVICE_ENUM.MOBILE]: '375px',
    [DEVICE_ENUM.TABLET]: '769px',
} as const;
